import { UserRoleAssignment } from './UserRoleAssignment';
import UserDetailsRole from './UserDetailsRole';
import { TenantUser } from './TenantUser';

export class UserDetail {
    id?: string;
    tenantId?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    status?: string;
    email?: string;
    lastLogin: Date | undefined;
    roles?: UserDetailsRole[] = [];

    constructor(user: TenantUser, roleAssignments: UserRoleAssignment[]) {
        this.id = user.id;
        this.name = user.name;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.status = user.status;
        this.email = user.email;
        this.tenantId = user.tenantId;
        this.lastLogin = user.lastLogin;

        if (roleAssignments && roleAssignments.length > 0) {
            roleAssignments.forEach((roleAssignment) => {
                this.roles!.push(new UserDetailsRole(roleAssignment.scope, roleAssignment.role, roleAssignment.parentAssignment));
            });
        }
    }
}
